import sdfLogo from '../Assets/images/sdf-logo.png';
function Brand() {
    return (
        <a href='/dashboard' className="font-bold text-2xl d-block">
            <img src={sdfLogo} alt="POS-Shudh Desi Fashion" style={{ height: '50px' }} />
        </a>
    )
}
export default Brand